module.exports = __webpack_public_path__ + "img/default_paquete.9b32ac6b.jpg";